import React from 'react'
import { Navigate } from 'react-router-dom'
import lazyLoad from '@helper/lazy-load'

const router = [
    {
        index: true,
        element: <Navigate to="/app/goods"/>
    },
    {
        path: '/app/goods',
        element: lazyLoad(() => import('@pages/goods/components/main')),
        loader: () => ({ key: 'goods.goods', menuIndex: 2, icon: 'icon-xitong1', show: true }),
        children: [
            {
                index: true,
                element: lazyLoad(() => import('@pages/goods-list/components/main')),
                loader: () => ({ key: 'goods.list', activeMenu: '/app/goods' })
            },
            {
                path: '/app/goods/:goodsId',
                element: lazyLoad(() => import('@pages/goods-detail/components/main')),
                loader:() => ({ key: 'goods.detail', activeMenu: '/app/goods', show: true })
            }
        ]
    }
]

export default router
